import {
  GetPaymentHistoryParams,
  GetPaymentHistoryResponse,
  GetPaymentStatusForCancelResponse,
  GetPaymentStatusParams,
  GetPaymentStatusResponse,
  PostCancelPaymentBody,
  PostCancelPaymentResponse,
} from '@/types/payment.type';
import api from '../paymentIndex';

export const getPaymentHistory = async (body: GetPaymentHistoryParams) => {
  const res = await api.getAxios<
    GetPaymentHistoryResponse,
    GetPaymentHistoryParams
  >('/medical/history', body);
  return res.data;
};

export const patchCancelPayment = async (body: PostCancelPaymentBody) => {
  const { hospitalId, qrOrderIndex } = body;
  const res = await api.patchAxios<
    PostCancelPaymentResponse,
    PostCancelPaymentBody,
    null
  >(
    '/qr/cancel',
    {
      requestType: 'MEDICAL_USER',
      hospitalId,
      qrOrderIndex,
    },
    null,
  );
  return res.data;
};

export const getPaymentStatus = async (body: GetPaymentStatusParams) => {
  const { qrOrderId } = body;
  const res = await api.getAxios<
    GetPaymentStatusResponse,
    GetPaymentStatusParams
  >(`/medical/qr/${qrOrderId}`);
  return res.data;
};

export const getPaymentStatusForCancel = async (
  body: GetPaymentStatusParams,
) => {
  const { qrOrderId } = body;
  const res = await api.getAxios<
    GetPaymentStatusForCancelResponse,
    GetPaymentStatusParams
  >(`/medical/history/cancel/${qrOrderId}`);
  return res.data;
};
